import styled from 'styled-components';
import ImageLink from 'components/common/imageLink/imageLink';
import { isMobile } from 'react-device-detect';

export const Logo = styled(ImageLink)`
  margin-left: ${() => {
    if (isMobile) {
      return '40px';
    }
    return '0';
  }};
  pointer-events: ${({ disabled }) => {
    if (disabled) {
      return 'none';
    }
    return 'default';
  }};
`;

export default styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.panel.header.background};
  color: ${({ theme }) => theme.colors.panel.header.foreground};
  display: flex;
  flex-direction: row;
  height: 40px;
  justify-content: space-between;
  padding: 0.5em;

  .logo {
    .img {
      height: 1.5em;
    }
  }
`;
